module.exports = __webpack_public_path__ + "static/img/xzicon01.c40d0e82.png";